var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BasePaymentForm", {
    attrs: { showSecured: true },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function() {
          return [
            _c("div", { staticClass: "form-group mb-1" }, [
              _c("label", [
                _c("strong", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("apps.payment.message.item")) +
                      "\n        "
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group mb-1" },
              [_c("Table", { attrs: { invoice: _vm.invoice } })],
              1
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer-text",
        fn: function() {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("apps.payment.message.amounttotal")) +
                ":\n    " +
                _vm._s(
                  _vm.getCurrencyWithNumber(
                    _vm.numberel(_vm.invoice.total, "0,0.00")
                  )
                ) +
                "\n  "
            )
          ]
        },
        proxy: true
      },
      {
        key: "footer-actions",
        fn: function() {
          return [
            _c("BaseButton", {
              attrs: { text: _vm.$t("button.next"), className: "btn-web" },
              on: { click: _vm.onClickNext }
            })
          ]
        },
        proxy: true
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-314cb3e2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-314cb3e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/InvoiceList.vue
// module id = null
// module chunks = 